import {Mapper} from '@s-ui/domain'

export class CloseDealersResponseToValueObjectSellerMapper extends Mapper {
  /**
   * @implements Mapper
   * Use the raw response from the http repository to create an Close DealerScheduleListValueObject.
   *
   * @constructor
   * @param {Config} config
   * @param {Function} closeDealerScheduleListVOFactory
   * @param {Function} closeDealerScheduleVOFactory
   * @param {Function} dealerEntityFactory
   * @param {Function} locationVOFactory
   *
   * @returns {CloseDealerScheduleListValueObject} closeDealerScheduleList
   */
  constructor({
    config,
    closeDealerScheduleListVOFactory,
    closeDealerScheduleVOFactory,
    dealerEntityFactory,
    locationVOFactory
  }) {
    super()

    this._config = config
    this._DEALER_TYPES = this._config.get('dealer').DEALER_TYPES
    this._closeDealerScheduleListVOFactory = closeDealerScheduleListVOFactory
    this._closeDealerScheduleVOFactory = closeDealerScheduleVOFactory
    this._dealerEntityFactory = dealerEntityFactory
    this._locationVOFactory = locationVOFactory
  }

  _getLocationVO = location => {
    const {address, city, geolocation, zipcode} = location

    return this._locationVOFactory({
      address,
      city,
      coordinates: {lat: geolocation.lat, lng: geolocation.long},
      postalCode: zipcode
    })
  }

  map = (rawList = []) => {
    const list = rawList
      .map(({dealer, distance, schedule}) => {
        if (schedule.length === 0) return null

        const {
          allowOnlineAppointment,
          dealerType,
          groupName,
          id,
          isRecommended,
          location,
          name,
          phone,
          predictionScore
        } = dealer

        const dealerEntity = this._dealerEntityFactory({
          allowOnlineAppointment,
          groupName,
          id,
          isRecommended,
          name,
          phoneNumber: phone,
          predictionScore: predictionScore ?? null,
          type: dealerType,
          ...(dealerType === this._DEALER_TYPES.PHYSICAL && {
            location: this._getLocationVO(location)
          })
        })

        return this._closeDealerScheduleVOFactory({
          dealer: dealerEntity,
          distance,
          schedule
        })
      })
      .filter(Boolean)

    return this._closeDealerScheduleListVOFactory({
      closeDealerScheduleList: list
    })
  }
}
